import Icon from 'veui/components/Icon'

Icon.register({
  'text-strikethrough': {
    paths: [
      {
        d: 'M704 352H436.24l-118.7-46.2c-38.6-15-63.54-48.44-63.54-85.14 0-30.83 17.9-51.45 32.91-63.32 23.36-18.46 56.61-29 94-29.88.66 0 1.33.07 2 .07C481 127.84 535 167.13 535 238.16a32 32 0 1064 0c0-50.8-18.92-94-54.72-124.87-37.14-32-89.76-48.76-156.45-49.72a32.67 32.67 0 00-3.45-.17c-53.14.3-101.85 15.83-137.15 43.73C210.32 136.3 190 176.62 190 220.66c0 53.63 29.41 102.63 77 131.34H64a32 32 0 000 64h360.23l79.23 30.83c38.6 15 63.54 48.45 63.54 85.15 0 26.66-15.16 52.74-42.68 73.43C495.15 627.35 455.91 640 416.65 640 259.09 639.89 226 562.89 226 498.28a32 32 0 00-64 0c0 60.3 21.42 111.07 61.95 146.83 44.15 39 108.85 58.77 192.31 58.89h1.06c52.63-.19 105.6-17.46 145.47-47.43 20.7-15.57 37.14-33.78 48.85-54.11 12.85-22.3 19.36-46 19.36-70.48 0-45-20.72-86.75-55.47-116H704a32 32 0 000-64z'
      }
    ],
    width: '768',
    height: '768'
  }
})
